export const locales =
    [
        {name: 'en', id: 'en'},
        {name: 'de', id: 'de'},
        {name: 'de-DE', id: 'de-DE'},
        {name: 'en-GB', id: 'en-GB'},
        {name: 'en-US', id: 'en-US'},
        {name: 'en-CA', id: 'en-CA'},
        {name: 'en-IN', id: 'en-IN'},
        {name: 'es', id: 'es'},
        {name: 'es-ES', id: 'es-ES'},
        {name: 'es-MX', id: 'es-MX'},
        {name: 'ja-JP', id: 'ja-JP'},
        {name: 'ko', id: 'ko'},
        {name: 'ko-KR', id: 'ko-KR'}
    ];

export const message_types =
    [
        {name: 'general', id: 'general'},
        {name: 'alexa', id: 'alexa'},
        {name: 'google', id: 'google'},
        {name: 'clova', id: 'clova'},
        {name: 'custom', id: 'custom'}
    ];

export const SSO = 'SSO';